// extend libraries
import {
  Dcml,
  dcmlFormat as remoteDcmlFormat,
  DcmlProps,
} from '@paywithextend/localization'
import React from 'react'
import { useNullSafeLocale } from 'src/localization/useNullSafeLocale'

export const dcmlFormat = (locale: string, amount: number): string => {
  return remoteDcmlFormat(locale)(amount)
}

type DcmlOwnProps = Omit<DcmlProps, 'locale'>

const DcmlContainer = (props: DcmlOwnProps): JSX.Element => {
  const locale = useNullSafeLocale()

  return <Dcml locale={locale} {...props} />
}

export default DcmlContainer
